// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringIsNumber } from 'validators/common'
import { MUST_BE_NUMERICAL_VALUE } from 'errors'

import {
  LOSS_CANNOT_BE_LESS_THAN_0,
  LOSS_CANNOT_BE_GREATER_THAN_999,
} from './errors'

const validateLoss = v => {
  if (v.length && (isNaN(v) || !stringIsNumber(v))) {
    return MUST_BE_NUMERICAL_VALUE
  } else if (+v < 0) {
    return LOSS_CANNOT_BE_LESS_THAN_0
  } else if (+v >= 1000) {
    return LOSS_CANNOT_BE_GREATER_THAN_999
  }
}

export default validateLoss
